export default "__VITE_ASSET__8c70d93b__"